module.exports = __webpack_public_path__ + "img/e518ed97f3c315d95b74eb0c1eddbf2f.00baab95.png";